import React from 'react';

export const Checkbox = ({ id, checked, onCheckedChange, label, iconLeft, iconRight }) => {
  return (
    <label className="checkbox" htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onCheckedChange(e.target.checked)}
        className="checkbox__input"
      />
      <span className="checkbox__box" />
      {iconLeft && <span className="checkbox__icon">{iconLeft}</span>}
      {label && (
        <span className={`checkbox__label ${checked ? 'checkbox__label--checked' : ''}`}>
          {label}
        </span>
      )}
      {iconRight && <span className="checkbox__icon">{iconRight}</span>}
    </label>
  );
};
